import { useRef } from 'react';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { MARS_LAYER } from 'foundations-components/transitional/constants';
// @ts-expect-error not migrated yet
import { getSmartRulesCount } from 'ContentEditorUI/lib/smartContent/utils';
import { checkModuleHasSmartRules } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
import { NamespaceWrapper } from 'EmailEditorUI/components/NamespaceWrapper';
import GrayScaleWhenHidden from 'LayoutBuilderUI/components/overlays/GrayScaleWhenHidden';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SMART_TYPES = {
  CONTACT_LIST: 'CONTACT_LIST',
  CONTACT_LIFECYCLE: 'CONTACT_LIFECYCLE',
  2: 'CONTACT_LIFECYCLE',
  3: 'CONTACT_LIST'
};
const SmartModuleLabel = ({
  element,
  isSelected = false,
  isNarrowColumn = false
}) => {
  const hasReportedSentry = useRef(false);
  const smartObjectsCount = getSmartRulesCount(element);
  const hasSmartRules = checkModuleHasSmartRules(element);
  const isTypeNotSmartOrNull = element.get('smart_type') === 'NOT_SMART' || element.get('smart_type') === null;
  if (!hasSmartRules || isTypeNotSmartOrNull) {
    if (smartObjectsCount > 0 && !hasReportedSentry.current) {
      const sentryMessage = isTypeNotSmartOrNull ? 'Module has smart objects but smart_type is NOT SMART or null' : 'Module has smart objects but no definition id';
      Raven.captureException(new Error(sentryMessage), {
        extra: {
          element: element.toJS()
        }
      });
      hasReportedSentry.current = true;
    }
    return null;
  }
  if (!isSelected) {
    const selectedSmartRuleId = element.get('selectedSmartRuleId');
    const smartType = element.get('smart_type');
    let info = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "layoutBuilder.elements.smartModuleHeader"
    });
    if (selectedSmartRuleId && SMART_TYPES[smartType]) {
      info = /*#__PURE__*/_jsx(FormattedMessage, {
        message: `layoutBuilder.elements.smartModuleHeaderRuleSelected.${SMART_TYPES[smartType]}`
      });
    }
    return /*#__PURE__*/_jsx(NamespaceWrapper, {
      children: /*#__PURE__*/_jsx(GrayScaleWhenHidden, {
        children: /*#__PURE__*/_jsx(Tag, {
          multiline: true,
          "data-test-id": "smart-rule-label",
          paddingInline: "200",
          paddingBlock: isNarrowColumn ? '100' : '0',
          position: "absolute",
          insetInlineEnd: "200",
          insetBlockStart: "200",
          zIndex: MARS_LAYER,
          children: /*#__PURE__*/_jsxs(TFlex, {
            alignItems: "center",
            children: [!isNarrowColumn && info, /*#__PURE__*/_jsx(HelpIcon, {
              "data-test-id": "smart-module-help-icon",
              title: /*#__PURE__*/_jsxs("span", {
                children: [isNarrowColumn && /*#__PURE__*/_jsxs("span", {
                  children: [info, ". "]
                }), /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "layoutBuilder.elements.smartModuleHeaderTooltip"
                })]
              }),
              tooltipPlacement: "bottom",
              marginInlineStart: !isNarrowColumn ? '200' : '0'
            })]
          })
        })
      })
    });
  }
  return null;
};
export default SmartModuleLabel;